module.exports = __webpack_public_path__ + "static/media/NotoSans-ExtraBoldItalic.05a7045f.ttf";